import { render, staticRenderFns } from "./validated_orders.vue?vue&type=template&id=72bd33be&scoped=true&"
import script from "./validated_orders.vue?vue&type=script&lang=js&"
export * from "./validated_orders.vue?vue&type=script&lang=js&"
import style0 from "./validated_orders.vue?vue&type=style&index=0&id=72bd33be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd33be",
  null
  
)

export default component.exports